import classNames from 'classnames';
import React from 'react';

import commonStyles from '../../../common.module.scss';

import image from './microsites.png';

export const MicrositesVariant: React.FC = () => (
  <div>
    <img
      className={commonStyles.image}
      src={image}
      alt="Illustration of a future webpage-builder feature"
    />
    <h2 className={commonStyles.h2}>
      Introducing a simple and beautiful way to show work online
    </h2>
    <p className={commonStyles.body}>
      Whether you want to create a personal page or business page, Quick Pages
      always look good and are ready to share within minutes. No coding. No
      fussy templates.
    </p>
    <ul className={classNames(commonStyles.body, commonStyles.list)}>
      <li>Drop in anything—watch it all snap into place</li>
      <li>Make your page public and private</li>
      <li>Create pages for your bio, portfolio, business, and more</li>
    </ul>
    <p className={commonStyles.body}>
      While we’re cooking up this new idea, we’d love to hear from you.
    </p>
  </div>
);

MicrositesVariant.displayName = 'MicrositesVariant';
